import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy, BulletIcon, HeaderTwo } from 'secondstep-components'
import TextLinkWithFileIcon from 'components/TextLinkWithFileIcon'

export const ChoiceLink = styled(TextLinkWithFileIcon)`
  align-self: flex-start;
`

export const ChoiceTitle = styled.span`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  margin-bottom: 0.25rem;
`

export const ChoiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1rem 1.25rem 0.375rem;
  border-radius: 0.625rem;
  background-color: ${themeGet('colors.paleGray')};
  margin-bottom: 1.25rem;
`

export const Header = styled(HeaderTwo)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  font-size: 1.4375rem;
  margin-bottom: 0.625rem;
`

export const HeaderBodyCopy = styled(BodyCopy)`
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
`

export const LinkWrapper = styled.div`
  display: flex;
  margin-bottom: 0.625rem;
`

export const PrepareWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 0.625rem;
  margin-bottom: 1.4375rem;
`

export const StyledBodyCopy = styled(BodyCopy)`
  font-family: ${themeGet('font.molde.regular')};
  font-size: 1rem;
  margin-bottom: 1.375rem;
`

export const StyledBulletIcon = styled(BulletIcon)`
  width: 0.9375rem;
  height: 0.9375rem;
  border-radius: 1.25rem;
  margin-right: 0.5rem;
  margin-top: 0.1875rem;
  color: ${themeGet('colors.blue')};
`

export const StyledHr = styled.hr`
  width: 100%;
  height: 2px;
  margin-bottom: 1rem;
  background-color: ${themeGet('colors.white')};
  border: none;
`
